var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueCountUp',{staticClass:"unitSmall",attrs:{"start-value":_vm.startVal,"end-value":_vm.currentVal,"options":_vm.options,"duration":6}})
}
var staticRenderFns = []

export { render, staticRenderFns }